import React, { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import PageHeader from "../components/PageHeader";
import { CheckCheck, Trash2, Loader2, AlertTriangle } from "lucide-react";

export default function Notifications() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/admin/notifications"); setRows(r.data); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const readAll = async () => {
    try { await api.post("/admin/notifications/read-all"); toast.success("Tümü okundu"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const clearAll = async () => {
    if (!window.confirm("Tüm bildirimler silinsin mi?")) return;
    try { await api.delete("/admin/notifications"); toast.success("Temizlendi"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <>
      <PageHeader title="Bildirimler" subtitle="Yetkisiz silme denemeleri ve sistem uyarıları"
        actions={
          <div className="flex gap-2">
            <button onClick={readAll} data-testid="read-all-btn" className="flex items-center gap-2 border border-zinc-300 hover:bg-zinc-50 text-sm font-semibold px-3 py-2 rounded-sm"><CheckCheck size={15} /> Tümünü Okundu Yap</button>
            <button onClick={clearAll} data-testid="clear-all-btn" className="flex items-center gap-2 border border-zinc-300 hover:bg-red-50 text-red-600 text-sm font-semibold px-3 py-2 rounded-sm"><Trash2 size={15} /> Temizle</button>
          </div>
        } />
      <div className="p-6 space-y-2">
        {loading ? (
          <div className="text-zinc-400 py-10 text-center"><Loader2 className="animate-spin inline" size={18} /> Yükleniyor...</div>
        ) : rows.length === 0 ? (
          <div className="text-zinc-400 py-10 text-center">Bildirim yok.</div>
        ) : rows.map((n) => (
          <div key={n.id} data-testid={`notif-${n.id}`}
            className={`flex items-start gap-3 border rounded-sm px-4 py-3 ${n.read ? "bg-white border-zinc-200" : "bg-amber-50 border-amber-300"}`}>
            <AlertTriangle size={18} className={n.read ? "text-zinc-400" : "text-amber-600"} />
            <div className="flex-1">
              <div className="text-sm text-zinc-800">{n.message}</div>
              <div className="text-xs text-zinc-400 mono mt-0.5">{n.user} · {n.at ? new Date(n.at).toLocaleString("tr-TR") : ""}</div>
            </div>
            {!n.read && <span className="text-[10px] font-bold bg-amber-600 text-white rounded-full px-2 py-0.5">YENİ</span>}
          </div>
        ))}
      </div>
    </>
  );
}
